import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative h-screen min-h-[600px] flex items-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/296ab9838c8a2f1e2b2bac03a156c5b2/904c643f8a4f542d75879134701ca292.png"
          alt="Vionne Stability Atelier"
          className="w-full h-full object-cover object-top"
          style={{ filter: 'brightness(0.93)', transform: 'scale(1.02)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 via-charcoal/20 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full px-6 sm:px-10 lg:px-24 pb-12 sm:pb-20 lg:pb-24">
        <div className="max-w-5xl mx-auto flex flex-col lg:flex-row items-end justify-between gap-6 sm:gap-12">
          <div>
            <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
              <div className="w-1.5 h-1.5 bg-bronze rounded-full animate-pulse"></div>
              <span className="text-white/50 text-[9px] sm:text-[10px] font-sans font-semibold tracking-[0.3em] sm:tracking-[0.4em] uppercase">
                Accepting May 10+ Sessions
              </span>
            </div>
            <h1 className="font-display font-light text-white italic leading-[0.9] tracking-tight">
              <span className="block text-5xl sm:text-7xl md:text-8xl lg:text-[100px]">Vionne</span>
              <span className="block text-5xl sm:text-7xl md:text-8xl lg:text-[100px] text-softGold">Stability</span>
              <span className="block text-3xl sm:text-5xl md:text-6xl lg:text-7xl text-white/60 mt-2 sm:mt-3">Method</span>
            </h1>
          </div>

          <div className="lg:max-w-[320px] flex flex-col gap-4 sm:gap-6">
            <p className="text-white/60 text-[12px] sm:text-[13px] font-sans font-light leading-[1.8] sm:leading-[1.9] border-l border-white/20 pl-4 sm:pl-5">
              Facial-Led Botanical Acupuncture<br />
              for Nervous System Stability.
              <br /><br />
              <span className="text-[10.5px] sm:text-[11.5px] text-white/50">
                Restoring Structural Integrity and Nervous System Resilience for Vancouver's High-Functioning Women.
              </span>
            </p>
            <div className="flex flex-col gap-2 sm:gap-3">
              <button
                onClick={() => navigate('/booking')}
                className="self-start px-6 sm:px-8 py-2.5 sm:py-3 bg-white/15 border border-white/40 text-white/90 rounded-full text-[9px] sm:text-[10px] font-sans font-semibold hover:bg-white/25 hover:border-white/60 transition-all duration-300 whitespace-nowrap cursor-pointer tracking-[0.2em] uppercase backdrop-blur-sm"
              >
                Reserve Your Session
              </button>
              <button
                onClick={() => navigate('/method')}
                className="self-start inline-flex items-center gap-2 text-white/50 hover:text-white/80 transition-colors duration-300 cursor-pointer group"
              >
                <span className="text-[9px] sm:text-[10px] font-sans font-semibold tracking-[0.2em] uppercase whitespace-nowrap">Explore the Method</span>
                <i className="ri-arrow-right-line text-xs w-4 h-4 flex items-center justify-center group-hover:translate-x-0.5 transition-transform duration-300"></i>
              </button>
              <span className="text-white/35 text-[8px] sm:text-[9px] font-sans tracking-[0.18em] uppercase pl-1">
                RAc. · CIDESCO · IFA/CFA certified aromatherapist&nbsp;·&nbsp;&nbsp;UK VTCT Level 4
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
